export default "__VITE_ASSET__D2Jjw4JU__"